import { render, staticRenderFns } from "./pro_detail.vue?vue&type=template&id=4fe6333f&"
import script from "./pro_detail.vue?vue&type=script&lang=js&"
export * from "./pro_detail.vue?vue&type=script&lang=js&"
import style0 from "./pro_detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports